if (!customElements.get('hotbath-shower-configurator')) {
  customElements.define('hotbath-shower-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.native = this.nextElementSibling;
      if (!this.native?.hasAttribute('data-hotbath-native') || this.inputsForSelection().length !== 3) return;
      this.bound = true;
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('keydown', (event) => this.onKeyDown(event));
      this.querySelector('[data-hotbath-controls]').hidden = false;
      this.native.hidden = true;
    }

    selected(kind) {
      return this.querySelector(`[data-hotbath-kind="${kind}"].is-selected`)?.dataset.hotbathValue || '';
    }

    inputsForSelection() {
      if (!this.native) return [];
      const selection = {
        Kleur: this.selected('color'),
        'Hoofddouche en arm': `${this.selected('diameter')} · ${this.selected('mount')}`,
        'Handdouche en houder': `${this.selected('hand')} · ${this.selected('holder')}`,
      };
      const radios = Array.from(this.native.querySelectorAll('input[type="radio"]'));
      return Object.entries(selection)
        .map(([name, value]) => radios.find((input) => input.dataset.optionName === name && input.value === value))
        .filter(Boolean);
    }

    markSelected(button) {
      this.querySelectorAll(`[data-hotbath-kind="${button.dataset.hotbathKind}"]`).forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
    }

    onClick(event) {
      const button = event.target.closest('[data-hotbath-kind]');
      if (!button || !this.contains(button) || button.disabled || button.classList.contains('is-selected')) return;
      const previous = this.querySelector(`[data-hotbath-kind="${button.dataset.hotbathKind}"].is-selected`);
      this.markSelected(button);
      const inputs = this.inputsForSelection();
      if (inputs.length !== 3) {
        if (previous) this.markSelected(previous);
        return;
      }
      inputs.forEach((input) => {
        this.native.querySelectorAll('input[type="radio"]').forEach((item) => {
          if (item.dataset.optionName !== input.dataset.optionName) return;
          item.checked = item === input;
          item.toggleAttribute('checked', item === input);
        });
      });
      const target = inputs[2];
      target.dataset.bvjFocusTarget = button.id;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onKeyDown(event) {
      const button = event.target.closest('[data-hotbath-kind]');
      const group = button?.closest('[role="radiogroup"]');
      if (!button || !group || !this.contains(button)) return;
      const buttons = Array.from(group.querySelectorAll('[data-hotbath-kind]')).filter((item) => !item.disabled);
      const current = buttons.indexOf(button);
      let next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % buttons.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + buttons.length) % buttons.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = buttons.length - 1;
      else return;
      event.preventDefault();
      buttons[next]?.focus();
      buttons[next]?.click();
    }
  });
}
